import React from 'react';
import { ArrowUpRightIcon, LockIcon } from 'lucide-react';
import { PageIntro } from '../components/PageIntro';
import { ContactBand } from '../components/ContactBand';
import { papers, researchAreas } from '../data/papers';
export function Research() {
  const published = researchAreas.filter(area => area.published);
  const unpublished = researchAreas.filter(area => !area.published);
  return <>
      <PageIntro eyebrow="Research" title="Most of our research is not published, and that is a deliberate choice." lead="The considerable majority of Research Science Group's research remains unpublished, both due to the desire to maintain proprietary trade secrets and due to the trade-off between spending time writing papers versus spending time directly pursuing R&D. In particular, very little of our practical research on pattern recognition, data analysis, or natural language processing has been published or publicly discussed." data-id="element-219" data-mp="3ghn4azqy4l06" />

      <section className="mx-auto max-w-6xl px-6 py-20 lg:px-10" aria-labelledby="publications" data-id="element-220" data-mp="3f6xi0hgkawb0">
        <div className="grid gap-12 lg:grid-cols-[0.8fr_1.6fr] lg:gap-20" data-id="element-221" data-mp="3a8duwdq8feh2">
          <div className="lg:sticky lg:top-28 lg:self-start" data-id="element-222" data-mp="3aa70rqt0tuo0">
            <p className="text-[11px] uppercase tracking-label text-accent" data-id="element-223" data-mp="3o8oo3nf0l55e">Published work</p>
            <h2 id="publications" className="mt-4 font-display text-[30px] leading-tight text-ink-950" data-id="element-224" data-mp="3j7r4r7i9q52b">
              Artificial General Intelligence and virtual agent control
            </h2>
            <p className="mt-4 text-[15px] leading-relaxed text-ink-500" data-id="element-225" data-mp="3t5x7tsft9h8r">
              We have published a number of papers discussing aspects of our longer-term research on
              Artificial General Intelligence and our work on virtual agent control. A few of them
              are linked here.
            </p>
          </div>

          <ol className="border-t border-ink-200" data-id="element-226" data-mp="krgbbhz58vhj">
            {papers.map(paper => <li key={paper.title} className="border-b border-ink-200" data-id="element-227" data-mp="ftwucab2a4lw">
                <a href={paper.href} className="group grid gap-2 py-7 sm:grid-cols-[4rem_1fr_auto] sm:items-baseline sm:gap-6" data-id="element-228" data-mp="39l37pc3953dy">
                  <span className="font-display text-sm text-ink-500" data-id="element-229" data-mp="3ik89qse0veuv">{paper.year}</span>
                  <span data-id="element-230" data-mp="3nb6rzxikmn0r">
                    <span className="block font-display text-[20px] leading-snug text-ink-950 transition-colors duration-150 ease-out group-hover:text-accent" data-id="element-231" data-mp="3nci20f2m0r0b">
                      {paper.title}
                    </span>
                    <span className="mt-1.5 block text-sm text-ink-500" data-id="element-232" data-mp="12f756ttk940">
                      {paper.venue} · {paper.area}
                    </span>
                  </span>
                  <ArrowUpRightIcon aria-hidden="true" className="h-4 w-4 text-ink-300 transition-colors duration-150 ease-out group-hover:text-accent" data-id="element-233" data-mp="a3vjhk472lav" />
                </a>
              </li>)}
          </ol>
        </div>
      </section>

      <section className="border-t border-ink-200 bg-paper-sunk" aria-labelledby="programs" data-id="element-234" data-mp="24dk8e288i7e5">
        <div className="mx-auto max-w-6xl px-6 py-16 lg:px-10" data-id="element-235" data-mp="1zl0qwu6fes42">
          <p className="text-[11px] uppercase tracking-label text-ink-500" data-id="element-236" data-mp="1umpimnvs4pny">Active lines of work</p>
          <h2 id="programs" className="mt-4 max-w-xl font-display text-[26px] leading-tight text-ink-950" data-id="element-237" data-mp="1po5y8rwu3lxp">
            What we are actually working on
          </h2>

          <div className="mt-10 grid gap-12 md:grid-cols-2 md:gap-16" data-id="element-238" data-mp="2n9k1jgcy7gzb">
            <div data-id="element-239" data-mp="2iduxazpzhbwo">
              <p className="text-sm text-accent" data-id="element-240" data-mp="2idcs3dlcfncm">Discussed publicly</p>
              <ul className="mt-4 space-y-5" data-id="element-241" data-mp="2dcffdgj3rlii">
                {published.map(area => <li key={area.title} className="border-t border-ink-200 pt-4" data-id="element-242" data-mp="29atsr3grnsv4">
                    <h3 className="font-display text-[19px] text-ink-950" data-id="element-243" data-mp="11yte4wzyxtgm">{area.title}</h3>
                    <p className="mt-1.5 text-[15px] leading-relaxed text-ink-700" data-id="element-244" data-mp="xwyc1qa7rc1s">{area.note}</p>
                  </li>)}
              </ul>
            </div>
            <div data-id="element-245" data-mp="2lrbgheal5v9t">
              <p className="flex items-center gap-2 text-sm text-ink-500" data-id="element-246" data-mp="2qk4kfzy8czku">
                <LockIcon aria-hidden="true" className="h-3.5 w-3.5" data-id="element-247" data-mp="2qm7in79jdz0n" />
                Held proprietary
              </p>
              <ul className="mt-4 space-y-5" data-id="element-248" data-mp="2gub9n15wwohn">
                {unpublished.map(area => <li key={area.title} className="border-t border-ink-200 pt-4" data-id="element-249" data-mp="34jw2qcvs524n">
                    <h3 className="font-display text-[19px] text-ink-950" data-id="element-250" data-mp="34ht0muhcrijk">{area.title}</h3>
                    <p className="mt-1.5 text-[15px] leading-relaxed text-ink-700" data-id="element-251" data-mp="39i79ufuowyj6">{area.note}</p>
                  </li>)}
              </ul>
            </div>
          </div>
        </div>
      </section>

      <ContactBand heading="Research only matters when it reaches a real problem." body="Ask us about the unpublished work. Under the right agreement, we can discuss a great deal more than what appears here." data-id="element-252" data-mp="2zmnjsa2t4u2c" />
    </>;
}